import React, {  Component } from 'react';

class SalesAgreementHandbook extends Component {
    render() {
        return (
            <div>
                <h1 className="pageTitle" style={{margin: '21px 0'}}>Customer Agreement Handbooks</h1>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--XQj3tEqJ--/xfrkskxnqqexy08fhx8t.pdf">Parts Distributor Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--VZCX4DUc--/xnpoqi27sqk5fdyxrybg.pdf">Monogram Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--oNknxgIa--/opojmkmjiz2gpcnzqyfh.pdf">Distributor Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--KOCGlCM8--/aoinmmazobslv1mt4s0m.pdf">Air & Water Distributor Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--ep_qtFhF--/u83qhfiz1etbluqnyxok.pdf">Commercial Laundry Reseller Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--P37R8MjW--/sqnctmvvyrw2wyh783s2.pdf">Dealer Handbook</a><span className="acroIcon" /><br />&nbsp;</p>  
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--qPFIiJTe--/sac5qiitbojohgvlkihe.pdf">As-Is Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
            </div>
        );
    }
}

export default SalesAgreementHandbook;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/SalesAgreement/salesAgreementHandbook.js